<div class="mfunsPlayer-danmaku-list-item">
  <div class="danmaku-time">{{ time }}</div>
  <div class="danmaku-text">{{ text }}</div>
  <ul class="danmaku-operate">
    <li class="danmaku-operate-item copy">复制</li>
    <li class="danmaku-operate-item report">举报</li>
  </ul>
</div>
